// CSS — global first, then page-specific, then utilities
import '../css/reset.css';
import '../css/font.css';
import '../css/galeria.css';
import '../css/styles.css';
import '../css/_actividades.css';
import '../css/_contacto.css';
import '../css/_galeria.css';
import '../css/_horarios.css';
import '../css/_inicio.css';
import '../css/_redes-sociales.css';
import '../css/_profesionales.css';
import '../css/_tarifas.css';
import '../css/responsive.css';
import '../css/responsiveslides.css';
import '../css/cookies.css';
import '../css/hamburger.css';

// jQuery plugins (ProvidePlugin makes $ / jQuery available globally)
import './libs/jquery.easing.1.3';
import './libs/responsiveslides.min';

// App modules
import { initAnalytics } from './analytics';
import './fecha';
import './cookies';
import App from './spa/App';

initAnalytics();

const app = new App();
app.start();
